import Image from 'next/image';
import applePayLogo from '@/public/public/images/applepay-logo.svg';
import gPayLogo from '@/public/public/images/gpay-logo.svg';
import mastercardLogo from '@/public/public/images/mastercard-logo.svg';
import visaLogo from '@/public/public/images/visa-logo.svg';
import { useConfigContext } from '@/app/providers/ConfigProvider';

type CardLogosProps = {
  isApplePaySupportedByPaymentGateway: boolean;
  isGooglePaySupportedByPaymentGateway: boolean;
};

export const CardLogos = ({
  isApplePaySupportedByPaymentGateway,
  isGooglePaySupportedByPaymentGateway,
}: CardLogosProps) => {
  const { isApplePaySupportedByBrowser, isGooglePaySupportedByBrowser } = useConfigContext();

  return (
    <div className="flex items-center mt-[12px]">
      <Image src={mastercardLogo} alt={'master card logo'} className="w-[42px] h-[30px] mr-[8px]" />
      <Image src={visaLogo} alt={'visa logo'} className="w-[49px] h-[16px] mr-[12px]" />
      <div className="flex gap-[12px]">
        {isGooglePaySupportedByPaymentGateway && isGooglePaySupportedByBrowser && (
          <Image src={gPayLogo} alt="google pay logo" className="w-[45px] h-[24px]" />
        )}
        {isApplePaySupportedByPaymentGateway && isApplePaySupportedByBrowser && (
          <Image src={applePayLogo} alt="apple pay icon" className="h-[24px] w-auto" />
        )}
      </div>
    </div>
  );
};
